module.exports = __webpack_public_path__ + "img/139.8.ffc3ec5c.png";